module.exports = __webpack_public_path__ + "static/how-it-works-backwater-valve-15be891d4e327cbf31a612eac6fe3fcb.gif";